import React, { useEffect, useState } from "react";
import styled from "styled-components";



const Advice = () => {
    const [advice, setAdvice] = useState("");

    useEffect(() => {
        const url = "https://api.adviceslip.com/advice";

        const fetchData = async () => {
            try {
                const response = await fetch(url);
                const json = await response.json();
                setAdvice(json.slip.advice);
            } catch (error) {
                console.log("error", error);
            }
        };

        fetchData();

    }, []);

    return (
        <Wrapper>
            <Paragraph>{advice}</Paragraph>
        </Wrapper>
    );
};

export default Advice;

const Wrapper = styled.div`
    margin: 0 auto;
`;

const Paragraph = styled.h2`
   

`;